import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  { namespace }: Boundaries["addResourceGroup"]["request"],
): State {
  const index = state.findIndex((req) => namespace === req.namespace);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { namespace, requestState: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { namespace, requestState: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  { namespace }: Boundaries["addResourceGroup"]["success"],
): State {
  const index = state.findIndex((req) => namespace === req.namespace);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { namespace, requestState: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { namespace, requestState: setRequestStateToSuccess() }];
}

function handleFailure(
  state: State,
  { namespace }: Boundaries["addResourceGroup"]["failure"],
): State {
  const index = state.findIndex((req) => namespace === req.namespace);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { namespace, requestState: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { namespace, requestState: setRequestStateToFailure() }];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.addResourceGroupRequested]: handleRequest,
    [events.addResourceGroupSucceeded]: handleSuccess,
    [events.addResourceGroupFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
